import React, { Fragment } from 'react';
import { bool, object, func } from 'prop-types';
import { resolve } from 'library/helpers/path-resolver';
import 'apps/billing/styles/components/completion-step.scss';

const CompletionStep = (props) => {

  let firstName =  resolve(props.user, 'first_name', false);
  return (
    <div className="completion-content">
      <svg viewBox="0 0 20 20">
        <path xmlns="http://www.w3.org/2000/svg" d="M2.92 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM6.7 9.29L9 11.6l4.3-4.3 1.4 1.42L9 14.4l-3.7-3.7 1.4-1.42z"/>
      </svg>
      {
        props.activatingSubscription ? (
          <Fragment>
            <h2>Thank you for Subscribing{firstName ? (`, ${firstName}.`) : '.'}</h2>
            <p>You have purchased a subscription.</p>
          </Fragment>
        ) : (
          <h2>Thank you{firstName ? (`, ${firstName}.`) : '.'}</h2>
        )
      }

    </div>
  );
};


export default CompletionStep;

CompletionStep.propTypes = {
  user: object,
  activatingSubscription: bool,
  getCurrentSubscriptionInfo: func
};
